import { withAuth } from 'hocs/auth/with-auth';
import { LayoutType, withLayout } from 'hocs/with-layout';
import { MoveMemoriesPage } from './move-memories-page';

const WrapAuth = withAuth(MoveMemoriesPage);
// Renders the vault top bar itself, like the other vault screens.
const WrappedMoveMemories = withLayout(LayoutType.Empty, WrapAuth);

export { WrappedMoveMemories as MoveMemories };
